import styled from "@emotion/styled"
import { css, keyframes } from '@emotion/react'
import facepaint from "facepaint"

import modal from 'react-modal'

const breakpoints = [640, 990]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

modal.setAppElement('#___gatsby')

const fadeInWTransform = keyframes`
  from {
    opacity: 0;
    transform: translate(50%, calc(-50% + 16px));
  }

  to {
    opacity: 1;
    transform: translate(50%, -50%);
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const modalMQ = css(mq({
  position: ["fixed", "fixed", "absolute"],
  top: [0, 0, "50%"],
  right: ["unset", "unset", "50%"],
  left: [0, 0, "unset"],
  width: ["100%", "100%", "unset"],
  height: ["100vh", "100vh", "unset"],
  height: ["100dvh", "100dvh", "unset"], /* eslint-disable-line no-dupe-keys */
  transform: ["none", "none", "translate(50%, -50%)"],
  animation: [`${fadeIn} 0.5s forwards ease`, `${fadeIn} 0.5s forwards ease`, `${fadeInWTransform} 0.5s forwards ease`],
  borderRadius: [0, 0, 20],
}))

export const Modal = styled(modal)`
  outline: none;
  background: var(--color-white);
  display: flex;
  overflow: hidden;
  ${modalMQ}
`
